export default function () {
    function build(entity) {
        if (!entity) throw Error('No supplied entity.');
        return {
            ...entity,
            class_route: classRoute(entity),
        };
    }

    async function get(idClass) {
        let item = null,
            error = null;
        try {
            const {data} = await useApi('classes').get('classes/' + idClass);
            item = build(data.class);
        } catch (e) {
            error = useApiError(e);
        }
        return {class: item, error};
    }

    async function post(params) {
        let item = null,
            error = null;
        try {
            const {data} = await useApi('classes').post('classes', params);
            item = build(data.class);
        } catch (e) {
            error = useApiError(e);
        }
        if (!item) item = params;
        return {class: item, error};
    }

    async function put(idClass, params) {
        let item = null,
            error = null;
        try {
            const {data} = await useApi('classes').put('classes/' + idClass, params);
            item = build(data.class);
        } catch (e) {
            error = useApiError(e);
        }
        if (!item) item = params;
        return {class: item, error};
    }

    async function remove(idClass) {
        let error = null;
        try {
            await useApi('classes').delete('classes/' + idClass);
        } catch (e) {
            error = useApiError(e);
        }
        return {error};
    }

    function classRoute(entity) {
        if (!entity.id_class) return undefined;
        return {
            name: 'classes-idClass',
            params: {
                idClass: entity.id_class,
            },
        };
    }

    return {build, get, post, put, remove};
}
